import React from "react";
import { StylesFromPageTheme } from "repoV2/components/Theming/StylesFromPageTheme";
import { useCheckoutThemeContext } from "../CheckoutThemeContextProvider";

const CheckoutStylesFromHostTheme = () => {
    const { font, colors } = useCheckoutThemeContext();

    return <StylesFromPageTheme font={font} colors={colors} />;
};

export default CheckoutStylesFromHostTheme;
